import { Blockquote as BlockquoteToExtend } from '@tiptap/extension-blockquote';

export const Blockquote = BlockquoteToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: {
                default: null
            }
        }
    }
})
